import { useTheme } from '@mui/material';

export const useContactsStyles = () => {
  const theme = useTheme();

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: 2,
      position: 'relative',
      zIndex: 0,
    },
    background: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: theme.palette.mode === 'light' ? '#f7f7f7' : '#121212',
      backdropFilter: 'blur(10px)',
      opacity: 0.8,
      zIndex: -1,
    },
    title: {
      marginBottom: 4,
      color: theme.palette.mode === 'light' ? 'textPrimary' : 'text.secondary',
    },
    button: {
      background: theme.palette.mode === 'light' ? 'linear-gradient(45deg, #ff6f00, #ff9100)' : 'linear-gradient(45deg, #ff9100, #ff6f00)',
      color: 'white',
      fontWeight: 'bold',
      borderRadius: '25px',
      textTransform: 'none',
      padding: '15px 40px',
      '&:hover': {
        background: theme.palette.mode === 'light' ? 'linear-gradient(45deg, #ff9100, #ff6f00)' : 'linear-gradient(45deg, #ff6f00, #ff9100)',
        transform: 'scale(1.05)',
      },
    },
    gridContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    gridItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
};
